import React, { Component, Fragment } from 'react';
import logoLogin from '../../assets/img/loginsmart.png';

import { Redirect } from 'react-router-dom'
import { API_URL } from '../../config'
import storage from '../../services/storage'
import social from '../../services/social'
import axios from '../../services/axios'
import * as Sentry from "@sentry/react";

import { InputGroup, FormGroup } from "@blueprintjs/core"

import moment from 'moment'

import './styles.css'

class Login extends Component {
  constructor(props){
    super(props)
    this.state = {
      auth: null
    }

    this.login = this.login.bind(this)
    this.onLogin = this.onLogin.bind(this)
  }

  setData(response){    
    const { data } = response
    const zone = moment().format('Z')
    const expiration = moment().add(data.exp, 'ms').subtract(2, 'days').utcOffset(zone).format()

    return Promise.all([
      storage.set('auth_token', data.token),
      storage.set('user', data),
      storage.set('expiration', expiration)
    ])
  }

  onLogin(){
    axios.post('login', {
      email: this.email.value,
      password: this.password.value
    }).then(this.setData)
    .then(()=>(window.location.href = '/home'))
    .catch((error)=>{
      Sentry.captureException(error)
    })
  }

  componentWillMount(){
    storage.get('auth_token')
    .then(()=>{
      this.setState({
        auth: true
      })
    }).catch(()=>{
      this.setState({
        auth: false
      })
    })
  }

  login(){
    return (
      <div className="anonimo">
        <Fragment>
          <div className="anonimoLogin">
            <div className="loginPanel">
              <img
                src={logoLogin}
              />
              <div className="loginForm">
                <FormGroup
                  label="Email"
                  labelFor="email"
                >
                  <InputGroup
                    inputRef={(email)=>(this.email = email)}
                    id="email"
                    placeholder="Email"
                  />
                </FormGroup>
                <FormGroup
                  label="Password"
                  labelFor="password"
                >
                  <InputGroup
                    inputRef={(password)=>(this.password = password)}
                    id="password"
                    type="password"
                    placeholder="Password"
                  />
                </FormGroup>
                <button 
                  onClick={this.onLogin}
                  className="bp3-button bp3-minimal button button-primary">
                  Iniciar Sesion
                </button>
              </div>
            </div>
          </div>
        </Fragment>
      </div>
    )
  }

  auth(auth){
    return (
      !!auth 
      ? <Redirect to='/home' />
      : this.login()
    )
  }

  render() {
    const { auth } = this.state
    return (
      auth != null 
      ? this.auth(auth) 
      : <div />
    )
  }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Anonimo/index.js